import Cookies from "js-cookie";
import CustomNotification from "../../Component/CustomNotification";
import configs from "../../config";
import moment from "moment";

export const handleErrorMessage = (error: any) => {
  CustomNotification({
    type: "error",
    message: "",
    description: getErrorMessage(error),
  });
  if (configs.APP_ENV !== "prod") {
    // tslint:disable-next-line: no-console
    console.log(error);
  }
};
export const handleSuccessMessage = (mes: string) => {
  CustomNotification({
    type: "success",
    message: mes,
    description: "",
  });
};

export const getErrorMessage = (error: any) => {
  return error?.response?.data?.errorMessage || "somethingWentWrong";
};
export const logout = () => {
  Cookies.remove("token");
  Cookies.remove("refreshToken");
  window.location.href = "/login";
};

export const getTimeDateRange = (date: any, unitTime: "day") => {
  // start time and end time of date
  const startDate = date
    ? moment(date).startOf(unitTime).format("YYYY-MM-DD")
    : null;
  const endDate = date
    ? moment(date).endOf(unitTime).format("YYYY-MM-DD")
    : null;

  // current date
  const currentTime = date ? moment(date).toISOString() : null;

  return { startDate, endDate, currentTime };
};
function isFullWidth(char: string) {
  const code = char.charCodeAt(0);
  return (
    (code >= 0x1100 && code <= 0x115f) || // Hangul Jamo
    (code >= 0x2329 && code <= 0x232a) || // Miscellaneous Technical
    (code >= 0x2e80 && code <= 0x2eff) || // CJK Radicals Supplement
    (code >= 0x3000 && code <= 0x303f) || // CJK Symbols and Punctuation
    (code >= 0x3040 && code <= 0x309f) || // Hiragana
    (code >= 0x30a0 && code <= 0x30ff) || // Katakana
    (code >= 0x31f0 && code <= 0x31ff) || // Katakana Phonetic Extensions
    (code >= 0x3400 && code <= 0x4dbf) || // CJK Unified Ideographs Extension A
    (code >= 0x4e00 && code <= 0x9fff) || // CJK Unified Ideographs
    (code >= 0xa960 && code <= 0xa97f) || // Hangul Jamo Extended-A
    (code >= 0xac00 && code <= 0xd7af) || // Hangul Syllables
    (code >= 0xf900 && code <= 0xfaff) || // CJK Compatibility Ideographs
    (code >= 0xfe10 && code <= 0xfe1f) || // Vertical Forms
    (code >= 0xfe30 && code <= 0xfe4f) || // CJK Compatibility Forms
    (code >= 0xff00 && code <= 0xffef) // Halfwidth and Fullwidth Forms
  );
}

export const displayStaffName = (staffName: string) => {
  let result = "";
  let length = 7;
  for (let char of staffName) {
    if (length <= 1 && staffName.length - result.length >= 2) {
      break;
    }
    if (isFullWidth(char)) {
      result += char;
      length -= 2;
    } else {
      result += char;
      length -= 1;
    }
  }

  return result !== staffName ? result + "..." : result;
};

export const toMinutes = (timeString: string) => {
  const time = moment(timeString, "HH:mm");
  return time.hours() * 60 + time.minutes();
};
